import React from "react";

export function Button({ children, className = "", variant = "primary", ...props }) {
  const baseStyle = "px-4 py-2 rounded-xl font-semibold transition-colors shadow";
  const variants = {
    primary: "bg-primary text-white hover:bg-secondary",
    secondary: "bg-secondary text-white hover:bg-primary",
    accent: "bg-accent text-textPrimary hover:bg-primary hover:text-white",
    outline: "border border-primary text-primary hover:bg-primary hover:text-white",
  };

  return (
    <button
      className={`${baseStyle} ${variants[variant]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
